import type { FunctionComponent, LazyExoticComponent, PropsWithChildren, PropsWithRef, ReactElement, ReactNode } from 'react';
import { lazy, Suspense } from 'react';

import ErrorBoundary from '@zen/Components/ErrorBoundary';

const loadable = <K extends {}, T extends PropsWithChildren<K> & PropsWithRef<K>>(
  importCallback: () => Promise<{ default: FunctionComponent<K> }>,
  fallback?: ReactNode
): FunctionComponent<T> => {
  const LoadedComponent: LazyExoticComponent<FunctionComponent<K>> = lazy(importCallback);

  return (props: T): ReactElement => (
    <ErrorBoundary>
      <Suspense fallback={fallback}>
        <LoadedComponent {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};

export default loadable;
